<script>
	import UISection from "../ui/UISection.svelte";
	import UIBreadcrumb from "../ui/UIBreadcrumb.svelte";
	import UICover from "../ui/UICover.svelte";
	import UIDate from "../ui/UIDate.svelte";
	import UITitle from "../ui/UITitle.svelte";
	import UILine from "../ui/UILine.svelte";
	import UITag from "../ui/UItag.svelte";
	import UIHeading from "../ui/UIHeading.svelte";
	import UIText from "../ui/UIText.svelte";
	import UIImage from "../ui/UIImage.svelte";
	import UIVideo from "../ui/UIVideo.svelte";
	import UILink from "../ui/UILink.svelte";
	import UITable from "../ui/UITable.svelte";
	import router from "../stores/router";
	import base from "../stores/base";

	let item = null;
	let itemId = "";

	function load() {
		if (window.payload) {
			item = window.payload;
			router.track(item.title);
		} else {
			fetch(process.env.APP_API + "/items/detail/" + itemId)
				.then((res) => {
					return res.json();
				})
				.then((json) => {
					if (json.message) {
						console.log("----", json.message);
						router.push("/404");
					} else {
						item = json;
						router.track(item.title);
					}
				})
				.catch((e) => {
					console.log("----error", e);
					router.push("/404");
				});
		}
	}

	$: {
		itemId = $router.params.id;
		load();
	}
</script>

{#key itemId}
	<main>
		{#if item}
			<UICover image={item.cover || $base.defaultCover}>
				<UIDate date={item.date} />
				<UITitle>{@html item.title.split("\n").join("<br>")}</UITitle>
				<UITag># {$base.categories[item.category][$base.lang]}</UITag>
			</UICover>
			<UISection center paddingtop="4em" paddingbottom="4em">
				{#each item.body as [type, data]}
					{#if type === "heading"}
						<UIHeading {data} />
					{:else if type === "text"}
						<UIText {data} />
					{:else if type === "image"}
						<UIImage {data} />
					{:else if type === "link"}
						<UILink {data} />
					{:else if type === "video"}
						<UIVideo {data} />
					{:else if type === "line"}
						<UILine {data} />
					{:else if type === "data"}
						<UITable {data} />
					{/if}
				{/each}
			</UISection>
			<UIBreadcrumb title={item.title} />
		{/if}
	</main>
{/key}
